import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';

const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://www.echt.gold';

const Bewertungen = () => {
  const reviews = [
    {
      name: 'Michael S.',
      city: 'Dortmund',
      rating: 5,
      date: 'November 2024',
      text: 'Sehr professionelle Abwicklung! Habe meine alte Rolex verkauft und einen fairen Preis erhalten. Die Bewertung war transparent und nachvollziehbar. Absolut empfehlenswert!'
    },
    {
      name: 'Anna K.',
      city: 'Düsseldorf',
      rating: 5,
      date: 'Oktober 2024',
      text: 'Schnelle und unkomplizierte Abwicklung beim Goldankauf. Die Mitarbeiter waren sehr freundlich und haben alles genau erklärt. Preis war top!'
    },
    {
      name: 'Thomas M.',
      city: 'Essen',
      rating: 5,
      date: 'Oktober 2024',
      text: 'Habe den Versandankauf genutzt - alles super organisiert. Das Paket war versichert und die Bewertung kam sehr schnell. Gerne wieder!'
    },
    {
      name: 'Sabine W.',
      city: 'Köln',
      rating: 5,
      date: 'September 2024',
      text: 'Tolles Service! Meine Diamantringe wurden professionell bewertet. Der Preis war fair und die Auszahlung erfolgte sofort. Sehr zu empfehlen!'
    },
    {
      name: 'Peter L.',
      city: 'Bochum',
      rating: 5,
      date: 'September 2024',
      text: 'Beste Erfahrung beim Silberverkauf. Faire Preise, keine versteckten Abzüge. Die Experten wussten wirklich, was sie tun. 5 Sterne!'
    },
    {
      name: 'Julia R.',
      city: 'Münster',
      rating: 5,
      date: 'August 2024',
      text: 'Sehr zufrieden mit dem Service. Hatte Altgold und Zahngold dabei - alles wurde präzise gewogen und bewertet. Klare Empfehlung!'
    }
  ];

  const renderStars = (rating) => {
    return Array(rating).fill(0).map((_, idx) => (
      <Star key={idx} size={18} fill="#d4af37" className="text-gold" />
    ));
  };

  return (
    <>
      <Helmet>
        <title>Bewertungen - Echt Gold | Kundenmeinungen</title>
        <meta name="description" content="Lesen Sie echte Kundenbewertungen zu Echt Gold. Erfahrungen mit unserem Ankauf von Gold, Silber, Uhren und Schmuck." />
        <link rel="canonical" href={`${BASE_URL}/bewertungen`} />
      </Helmet>

      <div className="bg-black/90 py-8 border-b border-gold/20">
        <div className="container mx-auto px-4">
          <div className="text-sm text-gray-400 mb-2">
            <Link to="/" className="hover:text-gold">Home</Link> / <span className="text-gold">Bewertungen</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold gold-text">Kundenbewertungen</h1>
        </div>
      </div>

      <section className="section section-dark">
        <div className="container">
          <div className="text-center mb-12">
            <div className="flex justify-center items-center gap-2 mb-4">
              {renderStars(5)}
              <span className="text-2xl font-bold text-gray-300 ml-2">4.8 / 5</span>
            </div>
            <p className="text-gray-400">Basierend auf über 250+ Bewertungen</p>
          </div>

          <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-6">
            {reviews.map((review, idx) => (
              <div key={idx} className="card" data-testid={`review-${idx}`}>
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <h3 className="font-bold text-lg">{review.name}</h3>
                    <p className="text-sm text-gray-400">{review.city}</p>
                  </div>
                  <div className="flex gap-1">
                    {renderStars(review.rating)}
                  </div>
                </div>
                <p className="text-gray-300 mb-3">{review.text}</p>
                <p className="text-sm text-gray-500">{review.date}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-darker">
        <div className="container">
          <div className="card text-center max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold mb-4 gold-text">Überzeugen Sie sich selbst!</h2>
            <p className="text-gray-300 mb-8">
              Werden Sie Teil unserer zufriedenen Kunden und erleben Sie fairen Service
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link to="/kontakt" className="btn-primary">Jetzt Termin vereinbaren</Link>
              <a href="tel:023139085116" className="btn-secondary">0231 39085116</a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Bewertungen;